import { j as o } from "./kezios-design-system.esm172.js";
import { IconComponent as n } from "./kezios-design-system.esm4.js";
const c = (r) => /* @__PURE__ */ o.jsx(n, { ...r, viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M5 15c-.9319 0-1.3978 0-1.7654-.1522a2.0003 2.0003 0 0 1-1.0824-1.0824C2 13.3978 2 12.9319 2 12V5.2c0-1.1201 0-1.6802.218-2.108a1.9999 1.9999 0 0 1 .874-.874C3.5198 2 4.08 2 5.2 2H12c.9319 0 1.3978 0 1.7654.1522.49.203.8794.5924 1.0824 1.0824C15 3.6022 15 4.0681 15 5m-2.8 17h6.6c1.1201 0 1.6802 0 2.108-.218a1.9996 1.9996 0 0 0 .874-.874C22 20.4802 22 19.9201 22 18.8v-6.6c0-1.1201 0-1.6802-.218-2.108a1.9998 1.9998 0 0 0-.874-.874C20.4802 9 19.9201 9 18.8 9h-6.6c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C9 10.5198 9 11.0799 9 12.2v6.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874.4278.218.9879.218 2.108.218Z"
  }
) });
export {
  c as IconCopy01
};
